import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`products/${id}/remove-image`)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/removeImage.js